import styled, {css} from 'styled-components';

import {
  Button as BaseButton,
  PeriodPicker as BasePeriodPicker,
  Button,
  NewCheckboxField,
} from '@edna/components';
import {Icon as BaseIcon} from '@edna/components/primitives';
import {mixins} from '@edna/components/styles';

export const Filters = styled.form`
  min-width: fit-content;
  ${({theme: {palette, spacing, duration, zIndex, borderRadius}}) => css`
    position: sticky;
    top: 68px;
    z-index: ${zIndex.dropdown};
    margin-bottom: ${spacing.s2};
    padding: ${spacing.s4};
    transition: top ${duration}ms;
    border: 1px solid ${palette.grey100};
    border-radius: ${borderRadius.br2};
    background-color: ${palette.white};
  `}
`;

export const Icon = styled(BaseIcon)`
  margin-right: ${({theme}) => theme.spacing.s1};
`;

export const FiltersCount = styled.div`
  ${mixins.stack({align: 'center', justify: 'center'})};
  ${mixins.wh('20px')};
  ${mixins.f1};
  color: ${({theme}) => theme.palette.white};
  background-color: ${({theme}) => theme.branding.colors.accentB};
  border-radius: 50%;
`;

export const LeftButton = styled(BaseButton)`
  display: flex;
  gap: ${({theme}) => theme.spacing.s1};
  justify-content: center;
  margin-right: auto;
`;

export const FormFooter = styled.div`
  ${mixins.stack({direction: 'ROW', size: '3', justify: 'space-between'})};
  margin-top: ${({theme}) => theme.spacing.s6};
`;

export const FilterButton = styled(Button)`
  position: relative;
  ${mixins.flexAlign('center')}
  ${({theme}) => css`
    gap: ${theme.spacing.s1};
  `}
`;

export const CheckboxGroup = styled.div<{columns?: number}>`
  display: grid;
  grid-template-columns: ${({columns = 3, theme}) =>
    `repeat(auto-fill, minmax(150px, calc((100% - ${theme.spacing.s6} * ${columns - 1})/ ${columns})))`};
  gap: ${({theme}) => theme.spacing.s2} ${({theme}) => theme.spacing.s6};
  width: 100%;
`;

export const FlatCheckboxGroup = styled.div`
  ${mixins.stack({direction: 'ROW'})};
  flex-wrap: wrap;
  gap: ${({theme}) => theme.spacing.s2} ${({theme}) => theme.spacing.s6};
  width: 100%;
`;

export const CheckboxField = styled(NewCheckboxField)`
  width: auto;
`;

export const FilterLabel = styled.label`
  ${mixins.stack({direction: 'ROW', size: '1', align: 'center'})};
  ${mixins.f2};
  color: ${({theme}) => theme.branding.content.secondary};
`;

export const FiltersSection = styled.section`
  ${mixins.stack({size: '4'})};
  width: calc(50% - 12px);
`;

export const PeriodPicker = styled(BasePeriodPicker)`
  width: 100%;
`;
